export default __webpack_public_path__ + "static/media/element_61.2a3e5f49.webp";